import $ from "jquery";
import "what-input";

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import "./lib/foundation-explicit-pieces";
import "slick-carousel/slick/slick";
import "hc-sticky/dist/hc-sticky";
import Splide from "@splidejs/splide";
//import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
// import LocomotiveScroll from "locomotive-scroll";
import "lazysizes";
// import gsap from "gsap";
// import ScrollTrigger from "gsap/ScrollTrigger";
// import AOS from "aos";
// import slidebars from "exports-loader?slidebars!Slidebars/dist/slidebars.js";
// import "simplelightbox/dist/simple-lightbox.jquery";

$(document).foundation();

var engineUtils = {
  init: function () {
    this.ui.init();
  },

  ui: {
    init: function () {
      engineUtils.ui.layout();
      engineUtils.ui.plugins();
    },

    layout: function () {
      // Directions
      var directionVal =
        $("html").css("direction").toLowerCase() === "rtl" ? "rtl" : "ltr";

      // sticky header
      if ($("#sticky-header").length) {
        var stickyHeader = new hcSticky("#sticky-header", {
          stickTo: "main",
          // onStart: function onStart() {
          //   $(".intro").slideUp();
          // },
          // onStop: function onStop() {
          //   $(".intro").slideDown("fast");
          // },
        });
      }

      // sticky sidebars
      if ($(".is-sticky").length) {
        var stickySide = document.getElementsByClassName("is-sticky");

        for (var i = 0; i < stickySide.length; i++) {
          new hcSticky(stickySide[i], {
            stickTo: stickySide[i].parentNode.parentNode,
            top: 0,
          });
        }
      }

      //Nav Toggle
      if ($(".nav-toggle-btn").length) {
        $(".nav-toggle-btn").on("click", function () {
          $(this).toggleClass("active");
          $(".navpanel").toggleClass("active");
        });

        $(".navpanel .nav__item a").on("click", function (event) {
          $(".navpanel").toggleClass("active");
          $(".nav-toggle-btn").toggleClass("active");
        });

        $(window).on("load", function () {
          if (window.location.hash !== "") {
            var target = window.location.hash,
              $target = $(target);

            $("html, body")
              .stop()
              .animate(
                {
                  scrollTop: $target.offset().top - 100,
                },
                200,
                "swing",
                function () {
                  window.location.hash = target;
                }
              );

            setTimeout(function () {
              $("html, body")
                .stop()
                .animate(
                  {
                    scrollTop: $target.offset().top,
                  },
                  100,
                  function () {
                    window.location.hash = target;
                  }
                );
            }, 1500);

            // var hash = window.location.hash;
            // $("html, body").animate(
            //   {
            //     scrollTop: $(hash).offset().top,
            //   },
            //   800,
            //   function () {}
            // );
          }
        });
      }

      // // Performances
      if ($(".focus-items .tabs-title").length) {
        $(".focus-items .tabs-title").on("mouseenter", function () {
          $(this)
            .find("a")
            .on("click", function (e) {
              e.preventDefault;
            });
        });
      }

      // bottom sticky on scroll
      $(window).on("scroll", function () {
        var st = $(this).scrollTop();
        if (st > 0) {
          $(".bottomStickyJs").addClass("active");
        } else {
          $(".bottomStickyJs").removeClass("active");
        }
      });

      // Modal
      if ($(".modal-toggle").length) {
        // text modal
        $(".modal-toggle").each(function () {
          var $this = $(this);

          $(this).on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var modalId, modalAttribute;

            modalAttribute = $this.data("modal");

            // get modal
            modalId = "#" + modalAttribute;

            console.log(modalId, "id");
            // toggle show modal
            $(modalId).toggleClass("is-visible");

            close(modalAttribute);
          });
        });

        // close
        function close(element) {
          var modal = "#" + element;
          // close modal
          $(".modal-close, .modal-overlay").on("click", function () {
            $(modal).removeClass("is-visible");
          });
        }

        // // dont include button to be clicked on modal
        // $(".modal-toggle .btn").on("click", function (e) {
        //   e.stopPropagation();
        // });

        // when user press esc close modal
        $(document).keyup(function (e) {
          if (e.key === "Escape") {
            // escape key maps to keycode `27`
            $(".modal.is-visible").removeClass("is-visible");
          }
        });
      }

      // select dropdown
      $(".select-dropdown__button").on("click", function () {
        $(this).siblings($(".select-dropdown__list")).toggleClass("active");
      });
      $(".select-dropdown__list-item").on("click", function () {
        var itemValue = $(this).data("value");

        $(this)
          .closest(".select-dropdown__list")
          .prev(".select-dropdown__button")
          .attr("data-value", itemValue)
          .find("span")
          .text($(this).text()),
          $(this).closest(".select-dropdown__list").toggleClass("active");
      });

      // font-change
      if ($(".font-change").length > 0) {
        //default fontsize
        //$('.fntChange_js').css('background', 'linear-gradient(to '+direction_opposite+', #000000 ' + value + '%, #DCEBE9 0%)' );

        var clicks = 0;

        $(".font-change").each(function (e) {
          var content = $(this).closest(".article-entry").find("p");
          var titles = $(this)
            .closest(".article-entry")
            .find(
              "p + h3, .entry-content h2,  .entry-content h3,  .entry-content > *"
            );

          var min = parseInt($(this).attr("font-min"));
          var max = parseInt($(this).attr("font-max"));
          var step = parseInt($(this).attr("step"));

          // pass min to currentValue;
          $(this).attr("font-value", min);

          var currentValue = parseInt($(this).attr("font-value"));

          console.log(currentValue, "current Vlaue");

          $(".font-change__increase").on("click", function () {
            if (currentValue <= max) {
              var increasedValue = (currentValue += step);

              $(this)
                .parents(".font-change")
                .attr("font-value", increasedValue);

              content.css({
                "font-size": increasedValue + "px",
                "line-height": "inherit",
              });

              titles.css({
                "font-size": increasedValue + "px",
                "line-height": "inherit",
              });

              return false;
            }
          });

          $(".font-change__decrease").on("click", function () {
            if (currentValue >= min) {
              var decreasedValue = (currentValue -= step);

              $(this)
                .parents(".font-change")
                .attr("font-value", decreasedValue);

              content.css({
                "font-size": decreasedValue + "px",
                "line-height": "inherit",
              });

              titles.css({
                "font-size": decreasedValue + "px",
                "line-height": "inherit",
              });

              return false;
            }
          });
        });
      }
    },

    plugins: function () {
      var directionVal =
        $("html").css("direction").toLowerCase() === "rtl" ? "rtl" : "ltr";

      if ($(".highlight-slider .splide").length) {
        $(".highlight-slider .splide").each(function (i, n) {
          var highlightSlider = new Splide(this, {
            pagination: true,
            arrows: false,
            direction: directionVal,
            // type: "loop",
            perPage: 1,
          });

          highlightSlider.mount();
        });
      }
    },
  },
};

$(document).ready(function () {
  engineUtils.init();
});

// import "../js/override.gn";
